import { useId } from 'react';
import formStyles from '~/styles/form.module.css';

type Props = {
  label: string;
  labelAffix?: React.ReactNode;
  checked: boolean;
  readonly?: boolean;
  disabled?: boolean;
  required?: boolean;
  onChange: (checked: boolean) => void;
};

export default function PlainCheckbox({
  label,
  labelAffix,
  checked,
  readonly = false,
  disabled = false,
  onChange,
  required = false,
}: Props) {
  const checkboxId = useId();

  return (
    <div className={formStyles.formCheckboxWrapper}>
      <input
        className={formStyles.formCheckbox}
        type="checkbox"
        value="1"
        id={checkboxId}
        checked={checked}
        disabled={readonly || disabled}
        onChange={(e) => onChange(e.target.checked)}
        required={required}
      />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label htmlFor={checkboxId}>
        {/* eslint-disable-next-line react/no-danger */}
        <span dangerouslySetInnerHTML={{ __html: label }} />
        {labelAffix}
      </label>
    </div>
  );
}
